import { useCompanyReadDataContext } from '@aibees/elephant/context';
import {
  useCompanyVisibilityState,
  useSearchTableFromRoute,
} from '@aibees/elephant/hooks';
import { usePageType } from '@aibees/elephant/hooks/use-page-type';
import { SearchTable } from '@aibees/elephant/types';
import { Icon } from '@aibees/shared/components';
import { Badge, Button } from '@mui/material';
import { memo } from 'react';
import type { CurrentCompanyContactDataItemProps as Props } from './types';

const BADGE_ANCHOR_ORIGIN = {
  vertical: 'top' as const,
  horizontal: 'right' as const,
};

export const CurrentCompanyContactDataItem = memo(
  ({
    className: _className,
    value,
    iconOrder: _iconOrder,
    icon,
    title: _title,
    onClick,
    isOpen: _isOpen,
    size: _size,
  }: Props) => {
    const { api } = useCompanyReadDataContext();
    const table = useSearchTableFromRoute();
    const { isCompanyPage } = usePageType();
    const isCompanyContext =
      table === SearchTable.Company || isCompanyPage || !!api?.data;
    const { showNoDataAvailable } = useCompanyVisibilityState();
    const shouldDisable =
      (!isCompanyContext && showNoDataAvailable) || !value?.length;
    return (
      <Button
        disableRipple
        onClick={onClick}
        size="xsmall"
        disabled={shouldDisable}
        variant="text"
      >
        <Badge
          badgeContent={
            value?.length && value?.length > 10 ? '+9' : value?.length
          }
          color="primary"
          variant="soft"
          anchorOrigin={BADGE_ANCHOR_ORIGIN}
          size={16}
        >
          <Icon
            size={22}
            name={icon}
            color={shouldDisable ? 'grey.400' : 'grey.500'}
          />
        </Badge>
      </Button>
    );
  }
);

CurrentCompanyContactDataItem.displayName = 'CurrentCompanyContactDataItem';
